<template>
  <div v-if="!loading">
    <div class="mb-3">
      <router-link :to="{ name: 'candidates' }" class="btn btn-sm btn-outline-secondary">
        <i class="fas fa-arrow-left"></i> Back to Candidates
      </router-link>
    </div>
    <div class="card px-3">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          Candidate: {{ user.full_name }}
          <span v-if="user.deleted_at" class="badge badge-danger ml-2">ARCHIVED</span>
        </h4>
        <div>
          <button
            v-if="!user.deleted_at"
            class="btn btn-outline-danger"
            @click="archiveUser"
          >
            <i class="fas fa-archive"></i> Archive
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            @click="restoreUser"
          >
            <i class="fas fa-undo"></i> Restore
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="card-text spaced-rows border-bottom-rows">
          <div class="row">
            <div class="col-3 font-weight-bold">ID</div>
            <div class="col-9">{{ user.id }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">First Name</div>
            <div class="col-9">{{ user.first_name }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Last Name</div>
            <div class="col-9">{{ user.last_name }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Email</div>
            <div class="col-9">{{ user.email }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Phone</div>
            <div class="col-9">{{ user.phone_number || '-' }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">City</div>
            <div class="col-9">{{ user.city || '-' }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Created</div>
            <div class="col-9">{{ user.created_at }}</div>
          </div>
          <div class="row">
            <div class="col-3 font-weight-bold">Status</div>
            <div class="col-9">
              <span
                class="badge"
                :class="user.deleted_at ? 'badge-danger' : 'badge-success'"
              >{{ user.deleted_at ? 'Archived' : 'Active' }}</span>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-4 text-center">
            <h5 class="text-muted">Applications</h5>
            <h3>{{ user.applications_count }}</h3>
          </div>
        </div>
      </div>
    </div>
    <UserAdminActions
      :user="user"
      api-base="jobboard-users"
      @updated="fetchUser"
    />
  </div>
</template>

<script>
import UserAdminActions from "@/components/Admin/UserAdminActions.vue";

export default {
  components: {
    UserAdminActions
  },
  props: {
    userId: {
      required: true,
      type: [String, Number]
    }
  },
  data() {
    return {
      user: {},
      loading: true
    };
  },
  async created() {
    await this.fetchUser();
  },
  methods: {
    async fetchUser() {
      this.loading = true;
      const { data } = await this.$http.get(`/enroll_admin/jobboard-users/${this.userId}`);
      this.user = data;
      this.loading = false;
    },
    archiveUser() {
      if (!confirm(`Archive user "${this.user.full_name}"? They will no longer be able to log in.`)) return;
      this.$http
        .post(`/enroll_admin/jobboard-users/${this.user.id}/archive`)
        .then(() => this.fetchUser());
    },
    restoreUser() {
      if (!confirm(`Restore user "${this.user.full_name}"?`)) return;
      this.$http
        .post(`/enroll_admin/jobboard-users/${this.user.id}/restore`)
        .then(() => this.fetchUser());
    }
  }
};
</script>
